export default __webpack_public_path__ + "static/media/cancer_trials_ai_ad.038ffe6b.png";